export default __webpack_public_path__ + "static/media/sgb-mitra-2.de40342d.svg";